<template>
	<div v-if="currentSupport" id="titre">
		<Breadcrumbs/>
		<div class="logo" v-html="currentSupport.logoSvgSupport"></div>
		<center class="subtitle has-text-white is-6">
			<p>{{currentSupport.description}}</p>
		</center>
		<br>
		<h1 class="title has-text-white is-5">
			<p>{{description}}</p>
		</h1>
		<div class="columns is-multiline">
			<div class="column is-one-third" v-for="bouton in currentSupport.boutons">
				<Bouton :bouton="bouton"/>
			</div>

		</div>
	</div>
</template>
<script>
	import Bouton from '@/components/Bouton.vue'
	export default {
		name: 'Titre',
		components:{Bouton},
		metaInfo() {
			if(this.currentSupport) {
				return this.setMeta({
					title : this.currentSupport.nom, 
					description : this.description,
					image : this.currentSupport.logoSvgUrl
				})	
			}
		},
		computed: {
			description() {
				return this.currentSupport.description_offres || 'Retrouvez sur cette page tous les offres associées au magazine '+this.currentSupport.nom;
			}
		}
	}
</script>

<style lang="scss">
.title svg {
	width: 100px;
}
#titre .logo svg{
	fill:white;
}
</style>